module.exports = __webpack_public_path__ + "static/media/SadToSeeYouGo.8f679568.png";